module.exports = __webpack_public_path__ + "img/011-operator.7ee2923c.png";